import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

// Sends current language param with every request
export const languageParamInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const translateService = inject(TranslateService);

  // Skip non-GET/POST requests
  if (!['GET', 'POST'].includes(request.method)) {
    return next(request);
  }

  // Do not alter static asset requests
  if (request.url.startsWith("assets/") || request.url.includes("/assets/")) {
    return next(request);
  }

  const currentLang = translateService.currentLang ?? 'fr';
  // Add the 'language' param via HttpParams
  const updatedParams = request.params.set('language', currentLang);
  const modifiedRequest = request.clone({ params: updatedParams });

  return next(modifiedRequest);
}